import Grid from "@material-ui/core/Grid/Grid";
import React, { PureComponent } from "react";
import { ReactMic } from "react-mic";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = {
  visualizer: {
    width: "100%"
  }
};

class Visualizer extends PureComponent {
  render() {
    const { isRecording, recordingUrl, onRecordingComplete, classes, onPlaybackEnded } = this.props;
    return (
      <Grid container direction="row">
        <Grid container>
          <Grid item xs={1} />
          <Grid item xs={10}>
            <ReactMic
              onSave={onRecordingComplete}
              visualSetting="sinewave"
              audioBitsPerSecond={256000}
              className={classes.visualizer}
              record={isRecording}
            />
          </Grid>
          <Grid item xs={1} />
        </Grid>
        {recordingUrl && (
          <Grid item xs={12}>
            <audio
              style={{ width: "100%" }}
              controls="controls"
              src={recordingUrl}
              controlsList="nodownload"
              onEnded={onPlaybackEnded}
            />
          </Grid>
        )}
      </Grid>
    );
  }
}

export default withStyles(styles)(Visualizer);
